import React from "react";
import { useApp } from "../../contexts";

export const ItemEarnBig = ({ value, ...props }) => {
  const { T } = useApp();
  const { btnLink, className, title, description } = props; 

  return (
    <div className={`w-full ${className}`}>
        <div
            className="drop-shadow"
            dangerouslySetInnerHTML={{
            __html: T(title),
            }}
        ></div>
        <div className={`w-full guild-description text-white drop-shadow`}>
            {T(description)}
        </div>
        <div className={`flex justify-start lg:mt-4 items-center gap-4`}>
            <a className="earn-big-btn" href={btnLink} target="_blank" >
                {T('Buy Art Now')}
            </a>
        </div>
    </div>
  );
};
